import ApiService from '../../../../../services/ApiService'
import ManageMeasurement from '../ManageMeasurement/ManageMeasurement.vue'
import DepartmentInactive from '../../../Department/deparmentInactive/departmentInactive.vue'

export default {
  components: {
    ManageMeasurement,
    DepartmentInactive,
  },

  props: {
    serviceOrderId: String,
  },

  async created() {
    this.institutionId = JSON.parse(localStorage.getItem('institution')).id
    if (this.serviceOrderId) {
      await this.getCalibration()

      this.departmentInactive =
        this.currentCalibration.equipment.department.status == 1
    }
  },

  data: () => ({
    loading: false,
    newMeasurementDialog: false,
    editMeasurementDialog: false,
    departmentInactive: false,
    dialogKey: false,
    withoutValues: false,
    institutionId: null,
    expanded: [],
    currentCalibration: {
      calibrationPatternTemplate: {},
      equipment: {},
    },
    currentMetricRange: {},
    headers: [
      {
        text: '',
        align: 'center',
        value: '',
        sortable: false,
      },
      {
        text: 'Métrica',
        align: 'center',
        value: 'metric',
        sortable: false,
      },
      {
        text: 'Res.Equip',
        align: 'center',
        value: 'resolutionEquipment',
        sortable: false,
      },
      {
        text: 'Padrão',
        align: 'center',
        value: 'pattern',
        sortable: false,
      },
      {
        text: 'Alias Param',
        align: 'center',

        value: 'alias',
        sortable: false,
      },
      {
        text: 'Unid.',
        align: 'center',

        value: 'unit',
        sortable: false,
      },
      {
        text: 'Res.',
        align: 'center',

        value: 'resolution',
        sortable: false,
      },
      {
        text: 'K',
        align: 'center',

        value: 'k',
        sortable: false,
      },
      {
        text: 'Incert.',
        align: 'center',

        value: 'uncertainty',
        sortable: false,
      },
      {
        text: 'Tend.',
        align: 'center',

        value: 'tendency',
        sortable: false,
      },
      {
        text: 'Faixa',
        align: 'center',

        value: 'range',
        sortable: false,
      },
      {
        text: 'VL1',
        align: 'center',

        value: 'valueOne',
        sortable: false,
      },
      {
        text: 'VL2',
        align: 'center',

        value: 'valueTwo',
        sortable: false,
      },
      {
        text: 'VL3',
        align: 'center',

        value: 'valueThree',
        sortable: false,
      },
      {
        text: 'VL4',
        align: 'center',

        value: 'valueFour',
        sortable: false,
      },
      {
        text: 'VL5',
        align: 'center',

        value: 'valueFive',
        sortable: false,
      },
    ],
    headersMobile: [
      {
        text: 'Métrica',
        align: 'center',

        value: 'metric',
      },
    ],
    headerProps: {
      sortByText: 'Ordenar por',
    },
    apiService: new ApiService(),
  }),

  computed: {},

  methods: {
    close() {
      this.$router.push('/calibration')
    },

    closeDialog() {
      this.newMeasurementDialog = false
      this.editMeasurementDialog = false
      const calibration = JSON.parse(sessionStorage.getItem('calibration'))
      this.currentCalibration = calibration
        ? calibration
        : this.currentCalibration
      this.getCalibration()
    },

    addMeasurement() {
      this.newMeasurementDialog = true
      this.dialogKey = !this.dialogKey
    },

    editMeasurement(value) {
      this.currentMetricRange = value
      this.editMeasurementDialog = true
      this.dialogKey = !this.dialogKey
    },

    async getCalibration() {
      this.loading = true
      await this.apiService
        .get(
          `calibration/getByServiceOrder/${this.institutionId}/${this.serviceOrderId}`
        )
        .then((response) => {
          this.currentCalibration = response.content
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    async openCertified() {
      const route = this.$router.resolve({
        path: `/printCalibrationCertified/${this.institutionId}/${this.currentCalibration.id}`,
      })
      window.open(route.href, '_blank')
    },

    getResolutionEquipment(value) {
      const parameter = this.currentCalibration.templateParameters.find(
        (x) => x.calibrationPatternTemplateParameterId === value
      )
      if (parameter) {
        return parameter.resolutionEquipment
      }
    },

    getAliasParameter(value) {
      const parameter = this.currentCalibration.templateParameters.find(
        (x) => x.calibrationPatternTemplateParameterId === value
      )
      if (parameter) {
        return parameter.calibrationPatternTemplateParameter.name
      }
    },
  },

  watch: {
    currentCalibration: {
      deep: true,
      handler() {
        this.changedData = true
      },
    },
  },
}
